import { render } from "./Impressium.vue?vue&type=template&id=1d22540a&scoped=true&ts=true"
import script from "./Impressium.vue?vue&type=script&lang=ts"
export * from "./Impressium.vue?vue&type=script&lang=ts"

import "./Impressium.vue?vue&type=style&index=0&id=1d22540a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d22540a"]])

export default __exports__